// Models
import { Dependency } from "../client/planner/dependency/Dependency";
import { DependencyItemType, DependencyType } from "../service/planner/enumerations/IPlannerEnumerations";
/**
 * Create a temporary (not-yet-persisted) dependency. Item types default to Task and the constraint
 * defaults to the basic Finish-to-Start relationship; archival/creation info use the constructor
 * defaults (non-archived). Used where a dependency object is needed before one exists — e.g.
 * resolving permissions for an add-dependency flow.
 * @param sourceItemId Id of the source (predecessor) item
 * @param targetItemId Id of the target (successor) item
 * @param constraint The dependency constraint type (defaults to Finish-to-Start)
 */ export function createTempDependency(sourceItemId, targetItemId, constraint = DependencyType.SourceFinishDrivesTargetStart) {
    return new Dependency({
        planId: "",
        sourceItemId,
        sourceItemType: DependencyItemType.Task,
        targetItemId,
        targetItemType: DependencyItemType.Task,
        constraint
    });
}
